// extracted by mini-css-extract-plugin
export default {"moveTo":"src-pages-SalesChannelCategory-ProductCategory-Table-css-module__moveTo--3RtYj"};